var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"is-fluid is-flex is-flex-direction-column is-align-items-center p-3"},[_c('Logo',{staticClass:"mb-5"}),_c('div',{staticClass:"form-container is-rounded is-max-widescreen"},[_c('Search')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }